import baseEnum from './base-enum'
export let userRoles = Object.assign(
  {},
  {
    Manager: 'manager',
    Boss: 'boss',
    Admin: 'admin',
    Client: 'client',
    User: 'user',
    Editor: 'editor',
    LoyaltyPartner: 'loyalty_partner',
    ManagerPartner: 'manager_partner',
    ContentManager: 'content_manager',
    ContentPromo: 'content_promo',
    ScheduleManager: 'schedule_manager',
    ObjectManager: 'manager_objects',
    JobManager: 'job_manager',
    ChecklistManager: 'checklists',
    ShopManager: 'shop_manager',
    ShopSale: 'shop_sale',
    SeoManager: 'seo_manager',
    SiteDevelopment: 'site_development'
  },
  {
    name(alias) {
      switch (alias) {
        case this.Manager:
          return 'Менеджер'

        case this.Boss:
          return 'Босс'

        case this.Admin:
          return 'Администратор'

        case this.Client:
          return 'Клиент'

        case this.User:
          return 'Пользователь'

        case this.Editor:
          return 'Редактор объектов'

        case this.LoyaltyPartner:
          return 'Я Партнер'

        case this.ManagerPartner:
          return 'Управляющий партнер'

        case this.ContentManager:
          return 'Контент-менеджер'

        case this.ContentPromo:
          return 'Контент-менеджер промосайтов'

        case this.ScheduleManager:
          return 'Управление расписанием'

        case this.ObjectManager:
          return 'Просмотр расписания'

        case this.JobManager:
          return 'Работа с вакансиями'

        case this.ChecklistManager:
          return 'Просмотр чеклистов'

        case this.ShopManager:
          return 'Администратор магазина'

        case this.ShopSale:
          return 'Продавец магазина'

        case this.SeoManager:
          return 'SEO-менеджер'

        case this.SiteDevelopment:
          return 'Специалист по развитию'
      }

      return alias
    },
  },
  baseEnum
)
